var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"content applicant-dash applicant-content active\"><ra-pagination options=\"pagination_options\" total=\"{{total_count}}\"></ra-pagination><div class=\"cf\"></div><applicant-appbundles-table displayed=\"applications\"></applicant-appbundles-table></div><div class=\"button-blue\"><div class=\"container\"></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/applicant/applicant.jade
// module id = 719
// module chunks = 0